<template>
  <div class="section-left">
    <h4 class="section-left-title">{{ $t('authorizationmanagement.initialauthorization.operationSectionTitleLeft') }}</h4>
    <div class="section-left-tab">
      <div class="section-left-tab-btn" :class="{ active:tabIndex == 0? true:false }" @click="btnClcik(0)">{{ $t('authorizationmanagement.initialauthorization.operationTabBtnInput') }}</div>
      <span />
      <div class="section-left-tab-btn" :class="{ active:tabIndex == 1? true:false }" @click="btnClcik(1)">{{ $t('authorizationmanagement.initialauthorization.operationTabBtnFile') }}</div>
    </div>
    <el-form ref="form" label-width="0px" class="section-left-content">
      <el-form-item v-show="tabIndex === 0" class="section-left-content-first">
        <el-input v-model="licenseNo" :placeholder="$t('authorizationmanagement.initialauthorization.operationTabBtnInputPlaceholder')" class="licenseNo" />
      </el-form-item>
      <el-form-item v-show="tabIndex === 1" class="section-left-content-second">
        <upload-select ref="upload" :value="value" :auto-upload="false" :limit="1" accept="lic/*" :on-exceed="handleExceed" :on-change="getFlie" @input="changeValue" />
      </el-form-item>
      <el-button type="primary" class="submit" @click.native.prevent="handleVerification">{{ $t('authorizationmanagement.initialauthorization.btnSubmit') }}</el-button>
    </el-form>
  </div>
</template>

<script>
import UploadSelect from '@/components/select/upload-select/upload-select'
import Submit from '../config/submit'

export default {
  components: {
    UploadSelect
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tabIndex: 0,
      licenseNo: '',
      returnFile: []
    }
  },
  methods: {
    btnClcik(index) {
      this.tabIndex = index
    },
    getFlie(value) {
      console.log(value)
      this.returnFile = value.raw
    },
    changeValue(value) {
      this.$emit('input', value)
    },
    handleExceed() {
      this.$message.warning(this.$t('common.onlyOneFileTip'))
    },
    handleVerification() {
      const data = new FormData()
      switch (this.tabIndex) {
        case 0: {
          data.append('licenseNo', this.licenseNo.trim())
          new Submit(data, this.tabIndex)
          break
        }

        case 1:
          data.append('file', this.returnFile)
          new Submit(data, this.tabIndex)
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.section-left{
  padding: 20px;
  &-title{
    color: #333;
    font-size: 14px;
    font-weight: 600;
    margin: 0;
  }
  &-tab{
    overflow: hidden;
    margin-top: 15px;
    &-btn{
      float: left;
      margin: 0 14px;
      color: #757575;
      font-size: 12px;
      cursor: pointer;
    }
    &-btn:nth-of-type(1){
      margin-left: 0;
    }
    &-btn.active{
      color: #008ee3;
    }
    span {
      float: left;
      width: 1px;
      height: 12px;
      background-color: #D8D8D8;
      margin-top: 3px;
    }
  }
  &-content{
      margin-top: 30px;
      &-first{
        margin-bottom: 0;
        min-height: 51px;
        .licenseNo{
          width: 60%;
          height: 34px;
          line-height: 34px;
        }
        .el-form-item__content{
          margin-left: 0;
        }
      }
      &-second{
        margin-bottom: 0;
        min-height: 51px;
      }
  }
  .submit{
    // margin: 30px 0px 0px;
    font-size: 12px;
  }
}
</style>
